import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import appConstants from "../../../../../../../../appConstants";
import { StyledRadioGroup } from "../../../common/RadioGroup";
import CheckboxGroup from "../../../common/CheckboxGroup";
import Select from "../../../../../../../common/StyledSelect";
import Collapse from "@material-ui/core/Collapse";
import { observer, inject } from "mobx-react";
import CustomTextField from "../../../common/CustomTextField";
import ShrinkWrap from "./ShrinkWrap";
import ExcessiveLength from "./ExcessiveLength";
import FormSectionHeader from "../../common/FormSectionHeader";
import PaymentDetails from "./../../Payment/PaymentDetails";
import { isPaymentDetailsRequired } from "../../Payment/util";
import SelectBills from "../SelectBills";
import { getPendingStops } from "../../../../../utils/utils";
import { withExceptionDetailsHOC } from "../ExceptionDetail";

@inject("DispatchStore")
@observer
class Form extends React.Component {
  handleChange = (name) => (value) => {
    const { handleChange } = this.props;
    if (["limitedAccessCode", "returnCode"].includes(name)) {
      value = value && value.value;
    }
    handleChange && handleChange(name)(value);
  };

  isSelectedOSNDException = () => {
    return this.props.DispatchStore.getExceptionDetails(
      this.props.editInfo?.exceptionType
    )?.isException;
  };

  isSelectedReturnCodeException = () => {
    return this.props.DispatchStore.getReturnDetails(
      this.props.editInfo?.returnCode
    )?.isException;
  };

  shouldDisplayExceptionField = () => {
    return (
      this.isSelectedReturnCodeException() || //in return flow, show if isException: true
      this.isSelectedOSNDException() //in DE flow show if OSND is selected
    );
  };

  render() {
    const { classes } = this.props;
    const {
      editInfo,
      errorInfo,
      shipmentData,
      children,
      forwardRef,
      routeData,
      stopData,
      stopHasMultiplePros,
      updateStopSelection,
      deliveryException,
    } = this.props;
    const isLimitedAccessChecked =
      editInfo.accessorials.length > 0
        ? editInfo.accessorials.find(
            (ele) => ele.name === appConstants.ACCESSORIAL.LIMITED_ACCESS
          )?.isChecked
        : false;
    const selectedReturnCode = editInfo.returnCode;
    const { ExceptionDetailsForm } = deliveryException;
    return (
      <React.Fragment>
        <div id={shipmentData.proId} ref={forwardRef}>
          {isPaymentDetailsRequired({
            deliveryStatus: editInfo.deliveryStatus,
            codAmount: shipmentData?.codAmount,
            freightAmount: shipmentData?.freightAmount,
          }) && (
            <PaymentDetails
              handleChange={this.handleChange}
              data={{
                freightAmount: shipmentData?.freightAmount,
                originalFreightAmount: shipmentData?.originalFreightAmount,
                freightPaymentType: editInfo.freightPaymentType,
                freightCheckNumber: editInfo.freightCheckNumber,
                freightAmountCollected: editInfo.freightAmountCollected,
                codAmount: shipmentData?.codAmount,
                originalCodAmount: shipmentData?.originalCodAmount,
                codPaymentType: editInfo.codPaymentType,
                codCheckNumber: editInfo.codCheckNumber,
                codAmountCollected: editInfo.codAmountCollected,
              }}
              errorInfo={errorInfo}
            />
          )}
          <FormSectionHeader label="Delivery Status" uppercase />
          <StyledRadioGroup
            onChange={this.handleChange("deliveryStatus")}
            options={this.props.DispatchStore.deliveryStatuses}
            helperText={errorInfo.deliveryStatus}
            error={Boolean(errorInfo.deliveryStatus)}
            value={editInfo.deliveryStatus}
          />
          {children}
          <Collapse
            in={editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DE}
            timeout="auto"
            unmountOnExit
          >
            <FormSectionHeader label={"OS & D Details"} uppercase />
            <StyledRadioGroup
              onChange={this.handleChange("exceptionType")}
              options={this.props.DispatchStore.exceptions}
              helperText={errorInfo.exceptionType}
              error={Boolean(errorInfo.exceptionType)}
              value={editInfo.exceptionType}
            />
          </Collapse>

          {editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN && (
            <React.Fragment>
              <FormSectionHeader label="Return Details" uppercase />
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: "returnCode",
                    label: "Select Return Code",
                    variant: "outlined",
                    helperText: errorInfo.returnCode,
                  }}
                  value={editInfo.returnCode}
                  error={Boolean(errorInfo.returnCode)}
                  onChange={this.handleChange("returnCode")}
                  data={this.props.DispatchStore.returnCodes}
                />
              </div>
            </React.Fragment>
          )}

          {this.shouldDisplayExceptionField() && (
            <ExceptionDetailsForm
              shipmentPieces={shipmentData.pieces}
              handleChange={this.handleChange}
              errorInfo={errorInfo}
              editInfo={editInfo}
              classes={classes}
              packageTypeList={this.props.DispatchStore.packageCodes}
            />
          )}

          {appConstants.SPECIAL_RETURNS.includes(selectedReturnCode) &&
            editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN && (
              <CustomTextField
                id="customerName"
                label="Customer (First and Last) Name"
                handleChange={this.handleChange("customerName")}
                error={errorInfo.customerName}
                value={editInfo.customerName}
                className={classes.fullWidth}
              />
            )}

          <Collapse
            in={
              ![
                appConstants.DELIVERY_CODE.RTN,
                appConstants.DELIVERY_CODE.SND,
              ].includes(editInfo.deliveryStatus)
            }
            timeout="auto"
          >
            <FormSectionHeader label="Accessorials" uppercase />
            <CheckboxGroup
              options={
                editInfo.accessorials.length
                  ? editInfo.accessorials
                  : this.props.DispatchStore.deliveryAccessorials
              }
              onChange={this.handleChange("accessorials")}
            />
            {isLimitedAccessChecked && (
              <>
                <FormSectionHeader label="Limited Access Details" uppercase />
                <div className={classes.flexRow}>
                  <Select
                    textFieldProps={{
                      id: "limitedAccessCode",
                      label: "Limited Access",
                      variant: "outlined",
                      helperText: errorInfo.limitedAccessCode,
                    }}
                    error={Boolean(errorInfo.limitedAccessCode)}
                    value={editInfo.limitedAccessCode}
                    onChange={this.handleChange("limitedAccessCode")}
                    data={this.props.DispatchStore.limitedAccessList}
                  />
                </div>
              </>
            )}
          </Collapse>
          {![
            appConstants.DELIVERY_CODE.RTN,
            appConstants.DELIVERY_CODE.SND,
          ].includes(editInfo.deliveryStatus) && (
            <>
              {shipmentData.excessiveLength !==
                appConstants.EXCESSIVE_SHIPMENT.YES && (
                <ExcessiveLength
                  handleChange={this.handleChange}
                  editInfo={editInfo}
                  errorInfo={errorInfo}
                  maxAllowedTrailerLength={routeData.trailer.length}
                />
              )}
              <ShrinkWrap
                handleChange={this.handleChange}
                editInfo={editInfo}
                errorInfo={errorInfo}
              />
            </>
          )}
          {editInfo.deliveryStatus === appConstants.DELIVERY_CODE.TA &&
            !stopHasMultiplePros && (
              <SelectBills
                stopsList={getPendingStops(routeData.stops)}
                currentStopData={stopData}
                updateStopSelection={updateStopSelection}
              />
            )}
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(withExceptionDetailsHOC(Form));
